module.exports = __webpack_public_path__ + "19_iv.png?626cbc360d74d2cf0ca9347022555cb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_iv.png
// module id = 164
// module chunks = 0